import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */

export const users = [
  {
    _id: "4485af0a- 4e48 - 484b - a238 - 20ef2e9a6643",
    firstName: "CLaire",
    lastName: "Dunphey",
    username: "test@1",
    password: "test",
    bio: "Hi I am Claire! Let's Connect",
    link: "https://brittanychiang.com/",
    profilePicture: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1961&q=80",
    coverPicture: "https://images.unsplash.com/photo-1486134030336-39b1094bf33e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1607&q=80",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: "950b86eb-9da7-4250-aad9-c385fc362a60",
    firstName: "Aniket",
    lastName: "Parihar",
    username: "test@2",
    password: "test",
    bio: "Hi I am Aniket!",
    profilePicture: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
    coverPicture: "https://images.unsplash.com/photo-1486134030336-39b1094bf33e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1607&q=80",
    link: "https://redux-toolkit.js.org/usage/usage-guide",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: "2c276ef1-10e5-444a-83a4-8733e4103a85",
    firstName: "Luke",
    lastName: "Skywalker",
    username: "test@5",
    password: "test",
    bio: "Hi I am Luke!",
    profilePicture: "https://images.unsplash.com/photo-1579540252588-da0ee883560d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
    coverPicture: "https://images.unsplash.com/photo-1486134030336-39b1094bf33e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1607&q=80",
    link: "https://redux-toolkit.js.org/usage/usage-guide",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: "ec419370-3e80-4729-9624-2086bc42baae",
    firstName: "Harry",
    lastName: "Skywalker",
    username: "test@6",
    password: "test",
    bio: "Hi I am Harry!",
    profilePicture: "https://images.unsplash.com/photo-1644982652061-df82282e178d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
    coverPicture: "https://images.unsplash.com/photo-1486134030336-39b1094bf33e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1607&q=80",
    link: "https://redux-toolkit.js.org/usage/usage-guide",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: "0f14e362-698f-4734-882e-8b4d797d5f0c",
    firstName: "Ron",
    lastName: "Skywalker",
    username: "test@7",
    password: "test",
    bio: "Hi I am Ron!",
    profilePicture: "https://images.unsplash.com/photo-1644982647844-5ee1bdc5b114?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
    coverPicture: "https://images.unsplash.com/photo-1486134030336-39b1094bf33e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1607&q=80",
    link: "https://redux-toolkit.js.org/usage/usage-guide",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: "78cf8b2b-ae46-4110-ad9b-3eab0713401c",
    firstName: "Hermione",
    lastName: "Skywalker",
    username: "test@8",
    password: "test",
    bio: "Hi I am Hermione!",
    profilePicture: "https://images.unsplash.com/photo-1644982647711-9129d2ed7ceb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80",
    coverPicture: "https://images.unsplash.com/photo-1486134030336-39b1094bf33e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1607&q=80",
    link: "https://redux-toolkit.js.org/usage/usage-guide",
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
];
